import apiClient from '@/plugins/axios'

export default {
  getTipoProcessos() {
    return apiClient.get('tipoProcesso')
  },

  getTipoProcesso(id) {
    return apiClient.get(`tipoProcesso/${id}`)
  },

  postTipoProcesso(tipoProcesso) {
    return apiClient.post(`tipoProcesso`, { tipoProcesso })

  },

  putTipoProcesso(id, categoria) {
    return apiClient.put(`tipoProcesso/${id}`, { tipoProcesso })

  },

  deleteTipoProcesso(id) {
    return apiClient.delete(`tipoProcesso/${id}`)

  },

  getDropDown() {
    return apiClient.get(`tipoProcesso/dropdown`)
  },

}


// WEBPACK FOOTER //
// ./src/views/TipoProcesso/_services/TipoProcessoService.js